import React, { useCallback, useRef } from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import ThumbIconButton from '@wix/da-ds/pkg/thumbs/ThumbIconButton';
import { useFaveButton } from '../../../../FaveButton/useFaveButton';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
const FaveControl = ({ deviation, showStatNumbers = true, className })=>{
    const award_from_thumb = useFlag('award_from_thumb');
    const buttonRef = useRef(null);
    const { showStats } = useOverlayContext(deviation);
    const { isFavourite, faveCount, onClick: onFaveClick, biData } = useFaveButton(deviation);
    const handleClick = useCallback(()=>{
        onFaveClick();
        if (buttonRef.current) {
            buttonRef.current.blur();
        }
    }, [
        onFaveClick
    ]);
    return /*#__PURE__*/ React.createElement(ThumbIconButton, {
        ref: buttonRef,
        className: className,
        type: "fave",
        isEngaged: isFavourite,
        showStatValue: showStats && showStatNumbers && !(award_from_thumb && faveCount === 0),
        statValue: faveCount,
        onClick: handleClick,
        biData: biData
    });
};
FaveControl.displayName = 'FaveControl';
export default FaveControl;

//# sourceMappingURL=FaveControl.js.map